const $JQ = jQuery;
(function($){
  $(function(){
    var $table = $('table.zn-table');

    if ($table.length) {
      $table.find('tr:first-child th').each(function(){
        var $this = $(this),
            th = $this.text(),
            td = $this.index() + 1;
            
        $this.closest('table').find('td:nth-child('+td+')').attr('data-heading', th);
      });
    }
  });
})($JQ);